import { useSelector } from 'react-redux';

import { RootState } from '../../../app/rootReducer';
import { useCaseLock } from '../../../common/caseLocking/CaseLockContext';
import { NoraPermissionV2 } from '../../../common/constants/roles';
import { useAccess } from '../../../common/hooks/useAccess';
import { getAllTasks } from '../../tasks/slice/taskListSlice';
import { TaskTypes } from '../../tasks/types/taskTypes';

export interface NotesBottomDrawerLayout {
  visible: boolean;
  isOpen: boolean;
}

export function resolveNotesBottomDrawerLayout(
  hasNotesTask: boolean,
  etiDrawerOpen: boolean,
  canAddNote: boolean,
  isOpen: boolean,
): NotesBottomDrawerLayout {
  return {
    visible: hasNotesTask && !etiDrawerOpen && canAddNote,
    isOpen,
  };
}

export function useNotesBottomDrawerLayout(): NotesBottomDrawerLayout {
  const { isLockedForActions } = useCaseLock();
  const canBypassNotesLock = useAccess({
    permission: NoraPermissionV2.CAN_ADD_NOTES_ON_LOCKED_CASE,
  });
  const canAddNote = !isLockedForActions || canBypassNotesLock;
  const hasNotesTask = useSelector((state: RootState) =>
    getAllTasks(state.taskList).some(t => t.taskType === TaskTypes.NOTES),
  );
  const etiDrawerOpen = useSelector(
    (state: RootState) => state.drawerCoord.activeDrawer?.type === 'eti',
  );
  const isOpen = useSelector((state: RootState) => state.notesDraft.isOpen);

  return resolveNotesBottomDrawerLayout(
    hasNotesTask,
    etiDrawerOpen,
    canAddNote,
    isOpen,
  );
}
